<form [formGroup]="residentSelectForm" class="resident-select-form">
  <div
    class="backdrop"
    *ngIf="isBackdropVisible"
    (click)="closeSelect($event)"></div>

  <app-web-header-dropdown
    class="web-header-dropdown"
    #departmentSelectComponent
    label="Wohnbereich auswählen:"
    [control]="residentSelectForm.controls.department"
    [options]="customer()?.departments ?? []"
    [showSearch]="true"
    [optionTemplate]="departmentOptionTemplate"
    [searchPlaceholder]="'Wohnbereich suchen'"
    [isResidentDropdown]="false"
    (backdropChanged)="backdropChanged($event)"
    [selectedId]="department()?.departmentId"
    (selectionChange)="selectDepartment($event)">
    <div
      selected-item
      class="select-trigger"
      *ngIf="department() as department">
      <img [src]="department.iconUrl" class="select-icon" />
      <div class="option-info" style="padding-left: 0; width: 90%">
        <span class="trigger-name">
          {{ department.name }}
          {{ department.isB2B ? '(B2B)' : '' }}
        </span>
        <span class="option-total text-trim">
          <app-partner-logo
            *ngIf="department.partnerDepartmentId || department.isMyNeva"
            class="connext-logo"
            [partnerId]="department.partnerId"></app-partner-logo>
          €
          {{
            totals().departments[department.departmentId] || 0 | number: '1.2-2'
          }}
        </span>
      </div>
    </div>
  </app-web-header-dropdown>
  <ng-template #departmentOptionTemplate let-option>
    <div class="department-option-info">
      <img [src]="option.iconUrl" class="select-icon" />
      <div class="option-info">
        <span class="option-name text-trim">
          {{ option.name }} {{ option.isB2B ? '(B2B)' : '' }}
        </span>
        <span class="option-total text-trim">
          <app-partner-logo
            *ngIf="option.partnerDepartmentId || option?.isMyNeva"
            class="connext-logo"
            [partnerId]="option.partnerId"></app-partner-logo>
          €
          {{ totals().departments[option.id] | number: '1.2-2' }}
        </span>
      </div>
    </div>
  </ng-template>
  <app-web-header-dropdown
    [class.hidden]="department()?.isB2B"
    class="web-header-dropdown"
    #residentSelectComponent
    label="Bewohner:in auswählen:"
    [control]="residentSelectForm.controls.resident"
    [options]="department()?.people ?? []"
    [showSearch]="true"
    [useGetName]="true"
    [optionTemplate]="residentOptionTemplate"
    searchPlaceholder="Bewohner:in suchen"
    [isResidentDropdown]="true"
    (backdropChanged)="backdropChanged($event)"
    [selectedId]="resident()?.id"
    (selectionChange)="selectResident($event)">
    <div selected-item class="select-trigger" *ngIf="resident() as resident">
      <app-profile-avatar
        [name]="resident.getName()"
        [color]="resident.color"
        [image]="resident.image"
        [size]="35"></app-profile-avatar>
      <div class="option-info" style="width: 90%">
        <span
          class="trigger-name"
          [class.washy]="
            resident.active === 0 || (resident | hasNoValidPaymentMethod)
          ">
          {{ resident.getName({ withRoomNumber: true }) }}
        </span>
        <app-inactive-resident-alert
          *ngIf="resident.active === 0"
          [resident]="resident"></app-inactive-resident-alert>
        <app-no-connext-account-id-error
          *ngIf="
            resident | hasNoValidPaymentMethod
          "></app-no-connext-account-id-error>
        <span
          class="option-total text-trim"
          [class.washy]="
            resident.active === 0 || (resident | hasNoValidPaymentMethod)
          ">
          €
          {{ totals().residents[resident.id] || 0 | number: '1.2-2' }}
        </span>
      </div>
    </div>
  </app-web-header-dropdown>
  <ng-template #residentOptionTemplate let-option>
    <div class="resident-option">
      <app-profile-avatar
        [name]="option.getName()"
        [color]="option.color"
        [image]="option.image"
        [size]="35"></app-profile-avatar>
      <div class="option-info">
        <span
          class="option-name text-trim"
          [class.washy]="
            option.active === 0 || (option | hasNoValidPaymentMethod)
          ">
          {{ option.getName({ withRoomNumber: true }) }}
        </span>
        <app-inactive-resident-alert
          *ngIf="option.active === 0"
          [resident]="option"></app-inactive-resident-alert>
        <app-no-connext-account-id-error
          *ngIf="
            option | hasNoValidPaymentMethod
          "></app-no-connext-account-id-error>
        <span
          class="option-total text-trim"
          [class.washy]="
            option.active === 0 || (option | hasNoValidPaymentMethod)
          ">
          €
          {{ totals().residents[option.id] | number: '1.2-2' }}
        </span>
      </div>
    </div>
  </ng-template>
</form>
